import React from 'react'
import { useTranslation } from 'react-i18next';
import { DeleteVisa } from 'src/components/visaActions/DeleteVisa';
import { VisaItemType } from 'src/types'
import { createFileURL } from 'src/utils/new';
import { CancelVisas } from '../../CancelVisas';
import { Link } from 'react-router-dom';
import { ExtendVisa } from 'src/components/visaActions/ExtendVisa';

export const AgentData = ({ onSuccessMutate, record, selectedCrews }: { record: VisaItemType } & { onSuccessMutate: Function, selectedCrews: string[] }) => {

    const { t } = useTranslation();

    const { letter_number, automation_number, command_letter_number, command_letter_file, status, visa, id, crews , otb_file } = record

    const isAtabLetterSent = !!letter_number


    return (
        <>
            {
                isAtabLetterSent ?

                    <>
                        < div className='flex flex-row gap-8 whitespace-nowrap items-center' >
                            <span className='w-36 '>{t('CommandLetterNumber')}</span>
                            <span>{command_letter_number}</span>

                        </div >


                        <div className='flex flex-row gap-8 items-center whitespace-nowrap'>
                            <span className='w-36'>شماره اتوماسیون</span>
                            <span>{automation_number}</span>

                        </div>  </>
                    : <span className='text-sm text-center text-gray-800'>{t('WaitForNationalityOfficeLetter')}</span>}

            {command_letter_file && <button onClick={() => window.open(createFileURL(command_letter_file))}
                className='bg-amber-100 text-amber-600 border border-amber-600  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
                title={`${t('View')} ${t('ViewCommandLetter')}`}
            >
                {t('ViewCommandLetter')}
            </button>}

            {!!otb_file && <button onClick={() => window.open(`https://api.flysepehr.com/storage${otb_file}`)}
                className='bg-teal-100 text-teal-600 border-teal-600 border  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
                title={`${t('View')} OKTB`}
            >
                {t('View')} OKTB
            </button>}

            {status == 0 && < DeleteVisa visaId={id.toString()} onSuccessMutate={onSuccessMutate} />}

            <CancelVisas onSuccessMutate={onSuccessMutate} agentVisaId={crews?.[0]?.agent_visa_id} crows={crews.filter(i => selectedCrews.indexOf(i.crew_id) != -1)} />

            {!!visa?.residence && <ExtendVisa onSuccessMutate={onSuccessMutate} duplicate_visa_id={crews?.[0]?.agent_visa_id} crewsData={crews.filter(i => selectedCrews.indexOf(i.crew_id) != -1).map(i => ({ id: i.crew_id, job_id: i.job_id }))} />}

            {status == 0 && <Link to={`/pay-visa?visaId=${id}`} title={t('Pay')}>            <button
                className='bg-green-100 text-green-200  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
                title={t('Pay')}

            >
                {t('Pay')}
            </button></Link>}




        </>
    )
}
